<template>
  <div class="boon-row" @mouseenter="hovered = true" @mouseleave="hovered = false">
    <div class="cell selector">
      <b-form-checkbox v-show="calcSelectorVisible" :checked="selected" @change="onSelectedToggle" />
    </div>

    <div class="cell name">
      <router-link :to="calcLink">
        <b-icon v-if="!person.firstName" icon="pencil-fill" />
        {{ person.firstName }} {{ person.lastName }}
      </router-link>
    </div>

    <div class="cell cell-short-text">
      <router-link :to="calcLink">
        {{ person.phone }}
      </router-link>
    </div>

    <div class="cell">
      <router-link :to="calcLink">
        {{ person.email }}
      </router-link>
    </div>

    <div class="cell cell-address" />

    <div class="cell cell-short-text">
      <router-link :to="calcLink">
        {{ person.occupation }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'PersonListRow',

  props: {
    person: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    selectorVisible: {
      type: Boolean,
      default: undefined,
    },
  },

  data() {
    return {
      hovered: false,
    };
  },

  computed: {
    ...mapGetters(['getCompany']),

    company() {
      return this.getCompany(this.person.companyId);
    },

    calcLink() {
      return { name: 'EditPerson', params: { _id: this.person._id } };
    },

    calcSelectorVisible() {
      return this.selected || this.hovered || !!this.selectorVisible;
    },
  },

  methods: {
    onSelectedToggle() {
      this.$emit('update:selected', this.person, !this.selected);
    },
  },
};
</script>

<style scoped>
a:visited {
  color: inherit;
}

.cell {
  width: 300px;
  padding: 0 5px;
}

.cell.name {
  width: calc(322px - 1rem);
}

.cell.selector {
  min-width: 24px;
  max-width: 24px;
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/organisation/PersonListRow.vue